export function construirCancelacion({
  mesaId,
  total
}) {
  if (!mesaId) throw new Error("Mesa requerida");
  if (total == null) throw new Error("Total requerido");

  return {
    mesaId,
    total,
    metodoPago: "ninguno",
    estado: "cancelada",
    fecha_registro: new Date().toISOString(),
  };
}
